export default "__VITE_ASSET__a0fa7dfb__"